<div class="header">
  <h1>Chat</h1>
  <p *ngIf="count() > 0">You have {{ count() }} match(es). Absolutely terrifying.</p>
  <p *ngIf="count() === 0">No matches yet. The world is your oyster onthe Swipe tab.</p>
  <p class="hint">Tap a match to open chat. It sends real messages to me. Promise.</p>
</div>

<div class="actions" *ngIf="count() > 0">
  <button mat-stroked-button (click)="$event.stopPropagation(); clear()">
    <mat-icon>delete</mat-icon>
    Clear matches
  </button>
</div>

<div class="list" *ngIf="count() > 0">
  <mat-card class="match" *ngFor="let m of matches()" (click)="openMatch(m)" role="button" tabindex="0">
    <div class="row">
      <div class="avatar" [style.backgroundImage]="'url(' + (m.photoUrls?.[0] ?? '') + ')'"></div>
      <div class="meta">
        <div class="name">{{ m.name }} <span class="age">{{ m.age }}</span></div>
        <div class="bio">
          {{ lastMessage() || "No messages yet. Tap to open chat." }}
        </div>
      </div>
    </div>

  </mat-card>
</div>

